// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"026b7bac","341":"3b0ddf79","764":"d46a3b1c"}[chunkId] + ".chunk.js";
};